import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SurveyService } from '../../parti-view/survey/survey.service';

export const surveyResultResolver: ResolveFn<Object> = async (route) => {
  const service = inject(SurveyService);
  return await service.getSurveyResults();
};
